import {
    HttpGetAllCustomerIdCode,
  } from "@/service/boss/b2corder";
export default {
    data () {
        return {
            serviceCodeList: []
        }
    },
    created () {
        HttpGetAllCustomerIdCode().then(
            (res) => {
                // console.log(res)
                this.serviceCodeList = res.data.map((item) => {
                    return {
                        label: `${item.code}(${item.carrierServiceName})`,
                        value: item.code,
                        attach: {
                            ...item,
                        },
                    };
                });
            },
            (err) => {
                this.$VMessage.error(err.message);
            }
        );
    }
}